class Countdown extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.interval = null;
  }

  connectedCallback() {
    const dateStr = this.getAttribute('date');
    if (!dateStr) {
      this.shadowRoot.innerHTML = '<span>Data não definida</span>';
      return;
    } 
    
    const [day, month, year] = dateStr.split('/').map(Number);
    this.targetDate = new Date(year, month - 1, day, 0, 0, 0);

    this.render();
    this.interval = setInterval(() => this.render(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  render() {
    const now = new Date();
    let diff = this.targetDate - now;
    if (diff < 0) diff = 0;

    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);
    const seconds = Math.floor((diff / 1000) % 60);

    this.shadowRoot.innerHTML = `
      <strong>
        ${days}d ${hours}h ${minutes}m ${seconds}s
      </strong>
    `;
  }
}

customElements.define('offer-countdown', Countdown);

class OfferLimitDay extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    const dateStr = this.getAttribute('date');
    if (!dateStr) {
      this.shadowRoot.innerHTML = '<span>Data não definida</span>';
      return;
    }

    const [day, month, year] = dateStr.split('/').map(Number);
    this.targetDate = new Date(year, month - 1, day, 0, 0, 0);

    this.render();
  }

  render() {
    const day = new Intl.DateTimeFormat("pt-BR", {
      weekday: "long"
    }).format(this.targetDate)

    this.shadowRoot.innerHTML = `
      <span>
        ${day}
      </span>
    `;
  }
}

customElements.define("offer-limit-day", OfferLimitDay)